<div *ngIf="loginRequired || (!isLoading && !errorOccured); else noApp">
  <ref-ref-navbar #navbar (navbarHeight)="setContainerMarginTop($event)"></ref-ref-navbar>
  <!--   <lib-navbar #navbar (navbarHeight)="setContainerMarginTop($event)"></lib-navbar> -->
  <div class="container main pt-4" [ngStyle]="containerStyles">
    <router-outlet></router-outlet>
  </div>
  <ref-footer></ref-footer>
</div>

<ng-template #noApp>
  <div class="wrapper d-flex align-items-center justify-content-center m-5">
    <div *ngIf="isLoading && !errorOccured">
      <i class="fa fa-spinner fa-spin fa-7x"></i>
    </div>
    <div *ngIf="errorOccured">
      <h1 class="text-center">An error occured, please log out and contact your supplier</h1>
      <div class="d-flex justify-content-center">
        <button class="btn btn-primary" (click)="logout()" translate>LOGOUT</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>SELECT_CUSTOMER</h4>
  </div>
  <div class="modal-body">
    <h5 translate>SELECT_CUSTOMER_IN_THE_DROPDOWN_BELOW</h5>
    <!--  <lib-customer-select-dropdown (customerSelected)="customerSelected($event);"></lib-customer-select-dropdown> -->
  </div>
</ng-template>
